<template>
  <article>
    <div class="main">
      <div class="text">
        <h2>Spend less time on timecards and more time on what matters</h2>
        <div class="subtitle">
          Freelance Payment Systems turns your tax forms, time cards, and rental forms into a quick and easy digital form.
        </div>
        <div class="buttons">
          <v-btn
            color="primary"
            :to="{
              name: 'caps',
              params: {
                hash: '72be7463b6c48596c838aec6bd9ab4'
              },
              query:
                {
                  demo: 'true'
                }
            }"
          >
            Try it out →
          </v-btn>
          <!-- <v-btn
            id="app-bar-contact-us"
            color="primary"
            text
            :to="{
              name: 'contactUs'
            }"
          >
            Video demo
          </v-btn> -->
        </div>
      </div>
      <div class="image">
        <img
          :src="MainImageBG"
        >
        <img
          :src="MainImage"
        >
      </div>
      <div class="job-link">
        Did your production manager send you a job code?
        <v-btn
          outlined
          text
          :to="{
            name: 'job-code'
          }"
        >
          Enter Job Code
        </v-btn>
      </div>
    </div>
    <v-container class="what-is">
      <v-row>
        <v-col cols="12">
          <h1>What is FPS?</h1>
        </v-col>
      </v-row>
      <v-row class="about-row">
        <v-col
          cols="12"
          md="6"
          class="about-col"
        >
          <img
            :src="EasyToUseImage"
          >
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="about-col"
        >
          <div
            class="content"
          >
            <h2>Easy to use</h2>
            <div class="subtitle">
              Our software is web-based and doesn’t require downloading any apps or creating any new logins or accounts.<br>
              Once you’re set up, employees can fill out timecards easily from their phone.
            </div>
          </div>
          <div
            class="content"
          >
            <h2>Comprehensive</h2>
            <div class="subtitle">
              Our service automatically generates a digital form for Timecards, Tax (I-9, W-9, W-4), Wage-Theft, and Kit Rental
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div
      class="how-it-works"
      :style="{backgroundImage: `url(${require('@/assets/landing/background_gradient.png')})`}"
    >
      <v-container>
        <div class="size-restrict">
          <v-row>
            <v-col
              cols="12"
            >
              <h1>How does it work?</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
              class="how-step"
            >
              <img
                :src="Contact"
              >
              <div class="how-content">
                <h3>Sign Up</h3>
                <div>Sign up on our platform.</div>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="how-step"
            >
              <img
                :src="Link"
              >
              <div class="how-content">
                <h3>Get Job Link</h3>
                <div>Create new job and generate a job-specific link.</div>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="how-step"
            >
              <img
                :src="Send"
              >
              <div class="how-content">
                <h3>Send to Freelancers</h3>
                <div>Send out the link and start receiving forms via email.</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </div>

    <v-container
      class="interested"
    >
      <v-row
        cols="12"
      >
        <v-col>
          <h1>Interested?</h1>
        </v-col>
      </v-row>
      <v-row
        cols="12"
      >
        <v-btn
          color="primary"
          :to="{
            name: 'caps',
            params: {
              hash: '72be7463b6c48596c838aec6bd9ab4'
            },
            query:
              {
                demo: 'true'
              }
          }"
        >
          Try it out →
        </v-btn>
        <v-btn
          v-if="$vuetify.breakpoint.smAndUp"
          id="interested-contact-us"
          :to="{
            name: 'contactUs'
          }"
        >
          Contact Us
        </v-btn>
      </v-row>
    </v-container>
  </article>
</template>

<style scoped lang="scss">
  @import '@/scss/main';

  .v-btn {
    text-transform: unset;
    font-size: 18px;
    letter-spacing: normal;
    box-shadow: none;
    border-radius: 4px;
    height: 42px !important;
    padding: 12px;
    font-weight: 400;
  }

  .main {
    position: relative;
    display: grid;
    grid-template-columns: minmax(540px, 2fr) 3fr;
    grid-template-rows: 1fr auto;
    padding: 0 12px;
    min-height: calc(100vh - 64px);
    margin: 0 auto;
    max-width: 1785px;
    transition: padding 0.2s ease;
    gap: 40px;
  }

  .main .image {
    align-self: center;
    padding-bottom: 60px;
    position: relative;
    width: 100%;
    // top: 4vw;
  }

  .main .image img {
    width: 100%;
  }

  .main .image img:last-child {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  h1 {
    font-size: 3.5rem;
  }

  h2 {
    font-size: 3rem;
    font-weight: 500;
    line-height: 130%;
  }

  .what-is {
    max-width: 1185px;
    margin-bottom: 100px;
  }

  .size-restrict {
    max-width: 1185px;
    margin: 0 auto;
  }

  .text {
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .subtitle {
    font-size: 1.2rem;
  }

  .buttons {
    display: flex;
    gap: 16px;
  }

  .how-it-works {
    // min-height: 400px;
    background: #FBFBFC no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    padding: 60px 0;
  }

  .how-it-works .row {
    margin-bottom: 40px;
  }

  .row img {
    width: 80%;
  }

  .about-row img, .about-row .content {
    max-width: 560px;
  }

  .about-col {
    display: grid;
    align-items: center;
    justify-items: center;
  }

  .how-step {
    display: flex;
    gap: 8px;
  }

  .how-step img {
    width: 56px;
    position: relative;
    top: -8px;
  }

  #interested-contact-us {
    text-transform: unset;
    color: #06679D;
    background: #CDEDFF;
    font-size: 18px;
    letter-spacing: normal;
    box-shadow: none;
    border-radius: 4px;
    height: 42px;
    padding: 12px;
    font-weight: 400;
  }
  .interested h1 {
    font-size: 4rem;
  }
  .interested {
    text-align: center;
    margin-bottom: 160px;
  }

  .interested .row {
    justify-content: center;
    gap: 12px
  }

  .job-link {
    grid-column-start: 1;
    grid-column-end: 3;
    // position: absolute;
    // bottom: 0;
    // left: 50%;
    // transform: translateX(-50%);
    // // height: 60px;
    background: #F6F6F7;
    padding: 24px;
    // font-size: 1.1em;
    display: flex;
    gap: 12px;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-self: center;
    width: 70%;
    max-width: 620px;
  }

  @media screen and (max-width: 1785px) {
    .main {
      padding: 0 60px;
    }
  }

  @media screen  and (max-width: 1200px) {
    .main {
      grid-template-columns: minmax(360px, 2fr) 3fr;
    }
    .main .text h2 {
      font-size: 2rem;
    }
    .main .text .subtitle {
      font-size: 1rem;
    }
    .main .text {
      gap: 10px;
    }
  }

  @media screen and (max-width: 960px) {
    // .main .text h2 {
    //   font-size: 3rem;
    // }
    // .main .text .subtitle {
    //   font-size: 1.2rem;
    // }
    // .main .text {
    //   gap: 16px;
    // }
    .comprehensive {
      flex-direction: column-reverse;
    }
    .main {
      grid-template-columns: 1fr;
      grid-auto-rows: auto auto auto;
      padding: 0px;
      gap: 16px;
    }
    .main .text {
      padding: 0 20px;
    }
    .main .image {
      width: calc(100% - 40px);
      justify-self: center;
    }
    .job-link {

      grid-column-start: 1;
      grid-column-end: 2;
    }
    .main .image {
      grid-row: 1;
      align-self: flex-end;
      padding-bottom: 0;
    }
    .main .text {
      align-self: flex-start;
      justify-self: center;
      max-width: 560px;
    }
    // .about-row .content {
    //   // max-width: inherit;
    //   // justify-self: flex-start;
    // }

    .job-link {
      max-width: auto;
      width: 100%;
      padding: 12px;
    }

  }
  @media screen and (max-width: 640px) {
    .interested h1 {
      font-size: 12vw;
    }
  }
</style>

<script>
import AOS from 'aos';
import 'aos/dist/aos.css';
import MainImage from '../assets/main-image.png';
import MainImageBG from '../assets/main-image-bg.svg';
import LandingLogo from '../assets/LandingLogo.png';
import ComprehensiveImage from '../assets/image-comprehensive.png';
import EasyToUseImage from '../assets/image-easy-to-use.png';
import IconGroups from '../assets/landing/IconGroups.vue';
import Contact from '../assets/icon-contact.svg';
import Link from '../assets/icon-link.svg';
import Send from '../assets/icon-send.svg';

AOS.init();

export default {
  name: 'Landing',
  components: {
    IconGroups,
  },
  data() {
    return {
      LandingLogo,
      ComprehensiveImage,
      EasyToUseImage,
      Contact,
      Link,
      Send,
      MainImage,
      MainImageBG,
    };
  },
  computed: {
    handWidth() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return '20%';
      }
      return this.$vuetify.breakpoint.smAndUp ? '36%' : '100%';
    },
  },
};
</script>
